import { convertTaskIdToActionSubjectId } from './analytics/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { pushToBackend } from './push-to-backend';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { pollBackend } from './poll-backend';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { convertTaskIdToActionSubjectId, getProductType } from './analytics';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { localStorageProvider, setLocalStorageHasNavigatedFromLink } from './local-storage';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { isRoadmapRoute } from './roadmap-route';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getAdminHubUrl } from './get-admin-hub-url';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getConnectActionLinkProps } from './get-connect-action-link-props';

export const getTaskIndex = (taskList: string[], taskId: string | null) => {
	if (!taskList || taskId === null) {
		return -1;
	}
	return taskList.indexOf(taskId) + 1;
};
type Word = string | null;

export const convertTaskIdToActionSubjectIdForShowMe = (taskId: Word) =>
	`${convertTaskIdToActionSubjectId(taskId)}ShowMe`;

export const convertTaskIdToActionSubjectIdForLink = (taskId: Word) =>
	`${convertTaskIdToActionSubjectId(taskId)}Link`;

export const convertTaskIdToActionSubjectIdForCta = (taskId: Word) =>
	`${convertTaskIdToActionSubjectId(taskId)}Cta`;
